import React from "react";
import { useSelector } from "react-redux";
import { Row, Col, Image } from "react-bootstrap";
import moment from "moment";

//STYLES
import * as FooterStyles from "../styles/footer";

//IMAGES
import logo from "../../../../../special/navBar/images/logo.jpg";

function Footer() {
    const printingShop = useSelector((state) => state.printingShop);

    function handlePolicyClick(fileName) {
        window.open(`/content/3dPrintingShop/policies/${fileName}`, "_blank");
    }

    function handleLinkClick(link) {
        window.open(link, "_blank");
    }

    return (
        <div style={FooterStyles.body}>
            <br />
            {printingShop.settings.footer}
            <div style={FooterStyles.bottomStyle}>
                <Row>
                    <Col style={FooterStyles.body}>
                        <strong>Policies</strong>
                        {printingShop.bottomFooterData.policies.map((policy, index) => {
                            return (
                                <div key={index} onClick={handlePolicyClick.bind(this, policy.fileName)} style={FooterStyles.linkText}>
                                    {policy.name}
                                </div>
                            );
                        })}
                    </Col>
                    <Col style={FooterStyles.body}>
                        <strong>{printingShop.settings.linksHeading != "" ? printingShop.settings.linksHeading : "Links"}</strong>
                        {printingShop.bottomFooterData.links.map((link, index) => {
                            return (
                                <div key={index} onClick={handleLinkClick.bind(this, link.link)} style={FooterStyles.linkText}>
                                    {link.title}
                                </div>
                            );
                        })}
                    </Col>
                    <Col style={FooterStyles.body}>
                        <Image src={logo} style={FooterStyles.imageSize} />
                        <p>&copy; {moment().year()}, High-View Studios</p>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default Footer;
